import React, { useState, useEffect } from "react";
import _ from 'lodash';
import { ApiRequest } from "../../../common/utils/api_request_utils";

const AmenitiesCheckBox = (props) => {
    const [amenities_list, setAmenitiesList] = useState([]);

    const handleCheck = (e) => {
        //console.log("checked", e.target.checked)

        if (e.target.checked) {
            props.setMustInclude([...props.must_include, e.target.value])
        } else {
            // var mustincl_arr = props.mustInclude_Arr;
            // var index = mustincl_arr.indexOf(e.target.value); // Let's say it's Bob.
            // if (index !== -1) {
            //     mustincl_arr.splice(index, 1);
            //     props.setMustIncludeArr(mustincl_arr)
            // }

            var removeItem = props.must_include.filter(item => item !== e.target.value)
            props.setMustInclude(removeItem)
        }
    }

    const handleChange = (selected) => {
        //console.log("checked", e.target.checked)
        let selectedValues = _.map(selected, 'value');
        props.setMustInclude(selectedValues)
        // if (e.target.checked) {
        //     props.setMustInclude([...props.must_include, e.target.value])
        // } else {
            // var mustincl_arr = props.mustInclude_Arr;
            // var index = mustincl_arr.indexOf(e.target.value); // Let's say it's Bob.
            // if (index !== -1) {
            //     mustincl_arr.splice(index, 1);
            //     props.setMustIncludeArr(mustincl_arr)
            // }

        //     var removeItem = props.must_include.filter(item => item !== e.target.value)
        //     props.setMustInclude(removeItem)
        // }
    }

    useEffect(() => {
        ApiRequest({
            method: "GET",
            url: `${process.env.GATSBY_STRAPI_SRC}/refined_keywords.json`
        }, (result) => {

            if(props.search_type_val === "sales"){
                setAmenitiesList(result.sales)
            } else{
                setAmenitiesList(result.lettings)
            }
            
        })
    }, [])

    var must_include_arr = [];
    // var must_include_object = Object.values(amenities_list).filter(item => item.length > 0 && item.map(item2 => must_include_arr.push({ label: item2.name, value: item2.slug })));
    var must_include_object = Object.values(amenities_list).filter(item => item.length > 0 && item.map(item2 => must_include_arr.push(item2)));

    //console.log("must_includes", props.must_include);
   var defaultValues =  must_include_arr.filter(option => _.includes(props.must_include, option.value) );
   //console.log("must_includes", defaultValues);
    return (
        <div className="container-box">
            {must_include_arr.length > 0 && must_include_arr.map((item, index) => {

                var checked_val = props?.must_include?.filter(value => value === item.slug)
                //var checked_val = ""
                return (
                    <label class="container-wrap">{item.name}
                        <input type="checkbox" value={item.slug} onChange={handleCheck} checked={checked_val.length > 0 ? true : false}></input>
                        <span class="checkmark"></span>
                    </label>
                )
            })}

            {/* <Select options={must_include_arr}
                isMulti={true}
                 placeholder={`Select Amenities`}
                value={defaultValues}
                className="react-select"
                classNamePrefix="react-select"
                onChange={(e) => {
                    handleChange(e)
                }}
            //   menuIsOpen={menuIsOpen}

            /> */}

        </div>
    );
};
export default AmenitiesCheckBox;